"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ComboBoxClearButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { type: "button", className: "c-form-control__elem c-form-control__clear u-btn-reset", "aria-label": "clear", tabIndex: -1, onClick: function (e) {
                // Prevent open on clear
                e.preventDefault();
                // Clear dropdown
                onClick();
            } },
            react_1.default.createElement("i", { className: "c-times c-times--xsmall" }))));
};
exports.default = ComboBoxClearButton;
